import api from './client';
import ApiError from './error';

const UserService = {
  async updatePushToken({ userId, token }) {
    try {
      const client = await api.getClient();
      return client.authLogin({ user: userId }, { push_token: token });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async registerUser({ user }) {
    try {
      const client = await api.getClient();
      return client.userRegister(null, user);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getUser({ id }) {
    try {
      const client = await api.getClient();
      client.interceptors.response.use((response) => response, (error) => {
        if (error?.response?.status === 401) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });
      return client.userShow(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getTarget() {
    try {
      const client = await api.getClient();
      client.interceptors.response.use((response) => response, (error) => {
        // API return 404 if the user has no entries in the journal
        // for requested date. This is not exactly an error, so we ignore, for now.
        if (error?.response?.status === 404) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });

      return client.targetShow();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateTarget({ target }) {
    try {
      const client = await api.getClient();
      return client.targetUpdate(null, target);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createTarget({ target }) {
    try {
      const client = await api.getClient();
      return client.targetCreate(null, target);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getUserAssignment({ user }) {
    try {
      const client = await api.getClient();
      return client.getUserAssignment(user);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default UserService;
